<template>
    <BreadCrumb PageTitle="Résultat" />
    <ResultatComposition />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ResultatComposition from "@/components/Composition/ResultatComposition.vue";
  
    export default defineComponent({
      name: "ResultatCompositionsPage",
      components: {
        BreadCrumb,
        ResultatComposition,
      },
    });
  </script>